import { FaSpinner } from 'react-icons/fa';
import { PartnerCompanyResult } from '../../../../../services/CnpjSpotService';

// ═══════════════════════════════════════════════════════════════
// INTERFACES & TYPES
// ═══════════════════════════════════════════════════════════════

interface PartnerCompaniesTabProps {
    companies: PartnerCompanyResult[] | null;
    loading: boolean;
    cleanDoc: string;
}

// ═══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════

export default function PartnerCompaniesTab({ companies, loading, cleanDoc }: PartnerCompaniesTabProps) {
    if (loading) {
        return <div className="flex items-center justify-center py-12"><FaSpinner className="animate-spin text-2xl text-blue-500" /></div>;
    }

    if (!companies || companies.length === 0) {
        return <div className="text-gray-500 text-center py-8">Nenhuma empresa encontrada para este CPF.</div>;
    }

    const maskedCpf = `***${cleanDoc.slice(3, 9)}**`;

    return (
        <div className="space-y-4">
            <p className="text-sm text-gray-500 mb-3">{companies.length} empresa(s) encontrada(s)</p>
            <table className="w-full text-sm border border-gray-200 dark:border-slate-600 rounded">
                <thead className="bg-gray-50 dark:bg-slate-700">
                    <tr>
                        <th className="text-left px-3 py-2">CNPJ</th>
                        <th className="text-left px-3 py-2">Razão Social</th>
                        <th className="text-left px-3 py-2">Qualificação</th>
                        <th className="text-left px-3 py-2">Entrada</th>
                        <th className="text-left px-3 py-2">Situação</th>
                        <th className="text-left px-3 py-2">UF</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-slate-600">
                    {companies.map((c, i) => {
                        const socio = (c as any).qsa?.find((s: any) => s.cnpj_cpf_do_socio === maskedCpf);
                        return (
                            <tr key={i} className="hover:bg-gray-50 dark:hover:bg-slate-700">
                                <td className="px-3 py-2 font-mono text-xs">{c.cnpj}</td>
                                <td className="px-3 py-2">{c.razao_social}</td>
                                <td className="px-3 py-2 text-xs">{socio?.qualificacao_socio || c.qualificacao_socio || '-'}</td>
                                <td className="px-3 py-2 text-xs">{socio?.data_entrada_sociedade || c.data_entrada_sociedade || '-'}</td>
                                <td className="px-3 py-2 text-xs">{c.descricao_situacao_cadastral}</td>
                                <td className="px-3 py-2">{c.uf}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
